module.exports = __webpack_public_path__ + "img/checked-success.e6442661.png";